module.exports = __webpack_public_path__ + "img/php-development-company.041fead6.webp";